import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseEventMessage } from 'entities/Message'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type ConversationMessagesStore } from 'widgets/ConversationMessages'

export const useEventMessageTranscriptFailed = (
  conversationMessageStore: ConversationMessagesStore
) => {
  const { websocket, conversationStore } = useEntitiesContext()
  const handler = (data: IResponseEventMessage) => {
    conversationStore.updateItem(data.conversation)

    if (data.message.conversation_id === conversationMessageStore.conversationId) {
      conversationMessageStore.updateTranscript(data.message)
      conversationMessageStore.updateRecordTranscriptStatus(data.message.id, 'failed')
    }
  }

  useEffect(() => websocket.on(WebsocketEvent.MessageTranscriptFailed, handler), [])
}
